import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import * as constants from 'PointOfSale/mockData';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import ServingOptionSubMenuComponent from 'PointOfSale/modules/servingOptionCategory/component';
import * as servingMenuItemsActions from 'PointOfSale/modules/servingOptions/state/actions';
import * as setDateAndSiteActions from 'PointOfSale/modules/setDateAndSite/state/action';
import * as POSSelectors from 'PointOfSale/selectors';
import { AlternateProvisionTypeEnum } from 'Common/Constants/Enumeration/AlternateProvisionTypeEnum';

class ServingOptionSubMenu extends Component {
  componentDidMount() {
    this.props.servingMenuItemsActions.getCEPTypes();
  }

  handleOnClickSubMenu = subMenu => {
    this.props.servingMenuItemsActions.setSelectedSubMenu(
      subMenu,
      this.props.currentSelectedMenu
    );
  };

  handleIncrement = () => {
    const timeDelay = 1;
    this.props.servingMenuItemsActions.setTimeInterval(timeDelay);
  };

  handleDecrement = () => {
    const timeDelay = -1;
    this.props.servingMenuItemsActions.setTimeInterval(timeDelay);
  };

  handleQuickServeItemChange = (e, { value }) => {
    const selectedItem =
      _.filter(this.props.filteredFoodItems, ['Description', value])[0] || null;

    this.props.servingMenuItemsActions.setQuickServeFoodItem(selectedItem);
  };

  handleCepTypeChange = (e, { value }) => {
    const selectedCepType = _.filter(
      this.props.cepTypes,
      type => type.Id === value
    )[0];
    this.props.setDateAndSiteActions.setCepType(selectedCepType);
  };
  render() {
    const {
      quickServeItems,
      filteredFoodItems,
      currentSelectedMenu,
      servingSubMenuItems,
      disabled,
      currentSession,
      children,
      selectedSiteDetails,
      types,
      selectedCepType,
      ...others
    } = this.props;

    return (
      <ServingOptionSubMenuComponent
        currentSelectedMenu={currentSelectedMenu}
        subMenus={servingSubMenuItems || constants.SUB_MENU}
        disabled={disabled}
        timeDelay={currentSession ? currentSession.timeInterval : 5}
        handleInputChange={this.handleInputChange}
        handleOnClickSubMenu={this.handleOnClickSubMenu}
        handleIncrement={this.handleIncrement}
        handleDecrement={this.handleDecrement}
        handleQuickServeItemChange={this.handleQuickServeItemChange}
        quickServeItems={quickServeItems}
        filteredFoodItems={filteredFoodItems}
        isCepOn={
          selectedSiteDetails &&
          selectedSiteDetails.AlternateProvisionTypeId ===
            AlternateProvisionTypeEnum.CEP
        }
        types={types}
        handleCepTypeChange={this.handleCepTypeChange}
        selectedCepType={selectedCepType}
        children={children}
        {...others}
      />
    );
  }
}

ServingOptionSubMenu.propTypes = {
  subMenus: PropTypes.object,
  currentSelectedMenu: PropTypes.string,
  selectedSiteDetails: PropTypes.object,
  disabled: PropTypes.bool,
  timeDelay: PropTypes.number,
  handleInputChange: PropTypes.func,
  handleIncrement: PropTypes.func,
  handleDecrement: PropTypes.func,
  handleQuickServeItemChange: PropTypes.func,
  quickServeItems: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  currentSession: PropTypes.object,
  children: PropTypes.node,
  types: PropTypes.array,
  filteredFoodItems: PropTypes.array,
  servingSubMenuItems: PropTypes.object,
};

const mapStateToProps = state => ({
  servingSubMenuItems: POSSelectors.getSubMenuItems(state),
  cepTypes: POSSelectors.cepTypes(state),
  types: POSSelectors.getCepTypes(state),
  currentSession: POSSelectors.getCurrentSession(state),
  selectedSiteDetails: POSSelectors.getSelectedSiteDetails(state),
  quickServeItems: POSSelectors.getQuickServeItemsDropdown(state),
  filteredFoodItems: POSSelectors.getSelectedFoodItems(state),
  selectedCepType: POSSelectors.getSelectedCepType(state),
});

const mapDispatchToProps = dispatch => ({
  servingMenuItemsActions: bindActionCreators(
    servingMenuItemsActions,
    dispatch
  ),
  setDateAndSiteActions: bindActionCreators(setDateAndSiteActions, dispatch),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ServingOptionSubMenu)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/servingOptionCategory/container/index.js